// extracted by mini-css-extract-plugin
export default {"bubble":"ChatBubbleSimple_bubble__1csM5","arrowDown":"ChatBubbleSimple_arrowDown__BElz+"};